<template>
  <div class="l-select-panel">
    <l-panel style="padding: 0">
      <template #toolLeft>
        <div class="l-panel--item" v-if="multiple">
          <el-radio-group
            v-model="showType"
            size="mini"
            @change="handleTypeChange"
          >
            <el-radio-button label="1">{{ $t("全部") }}</el-radio-button>
            <el-radio-button label="2">{{ $t("已选") }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="l-panel--item" v-if="showType == 1 || model == 'client'">
          <el-input
            style="width: 200px"
            :placeholder="$t('请输入查询关键字')"
            v-model="searchWord"
            size="mini"
            @clear="hanleSearchInput"
            @input="hanleSearchInput"
            @keyup.enter.native="hanleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="hanleSearch"
            ></el-button>
          </el-input>
        </div>
        <div class="l-panel--item l-select-panel--numText" v-if="multiple">
          {{ `${$t("已经选中")}${myValue.length}${$t("条")}` }}
        </div>
      </template>
      <template #toolRight>
        <el-button-group v-if="isRefresh">
          <el-button
            :disabled="disabledRefresh"
            size="mini"
            icon="el-icon-refresh-left"
            @click="handleRefresh"
          ></el-button>
        </el-button-group>
        <slot name="btns"></slot>
        <el-button-group v-if="multiple">
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="handleClear()"
            >{{ $t("清空") }}</el-button
          >
        </el-button-group>
      </template>
      <l-table
        :loading="selectLoading"
        :columns="columns"
        :dataSource="tableData"
        :isPage="isPage"
        :pageTotal="tableTotal"
        :tablePage.sync="tableCurrentPage"
        :pageSizes="[50, 100, 200]"
        :pageSize="tablePageSize"
        :pageLayout="pageLayout"
        :isMultiSelect="multiple"
        :reserveSelection="false"
        :isTree="isTree"
        :idKey="idKey"
        :pidKey="pidKey"
        :rowKey="rowKey"
        :default-expand-all="defaultExpandAll"
        :checkStrictly="notSelectChildren"
        multiSelectKey="checkKey"
        @select="handleSelect"
        @selectAll="handleSelect"
        @loadPageData="turnTablePage"
        @rowClick="handleRowClick"
        :sortable="sortable"
        ref="selectTable"
      >
        <template v-for="item in columns" v-slot:[item.prop]="scope">
          <slot v-bind="scope" :name="item.prop"></slot>
        </template>
        <slot></slot>
      </l-table>
    </l-panel>
  </div>
</template>
<script>
export default {
  name: "l-select-panel",
  props: {
    value: {
      type: String,
      default: "learun_no_prop",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    isTree: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
    },
    pidKey: {
      type: String,
    },
    defaultExpandAll: {
      type: Boolean,
      default: true,
    },
    model: {
      type: String,
      default: "service", //在分页下有效果  service（数据从后端加载） client （数据一次加载完）
    },

    columns: {
      type: Array,
      default: () => [],
    },
    loadSelectTable: {
      type: Function,
    },
    refreshData: {
      type: Function,
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },

    isChangeSearch: {
      type: Boolean,
      default: false,
    },

    notSelectChildren: {
      type: Boolean,
      default: true,
    },
    sortable: {
      type: Boolean,
      default: false,
    },

    isSaveSelectData:Boolean // 特定场合下使用
  },
  data() {
    return {
      searchWord: "",
      selectLoading: false,
      tableData: [],
      tableTotal: 0,
      tablePageSize: 50,
      tableCurrentPage: 1,
      showType: 1,
      disabledRefresh: false,

      clientData: [],

      tempValue:'',
      notRefreshTable:false,
      filterParams:null,
      selectData:[]
    };
  },
  mounted() {

  },
  computed: {
    myValue: {
      get() {
        let value = this.value
        if(value == 'learun_no_prop'){
          value = this.tempValue;
        }
        if (this.multiple) {
          if (!this.$validatenull(value)) {
            return (value + "").split(",");
          } else {
            return [];
          }
        } else {
          return value;
        }
      },
      set(val) {
        this.notRefreshTable = true;
        if (this.multiple) {
          this.tempValue = String(val);
          this.$emit("input", this.tempValue);
        } else {
          this.tempValue = val;
          this.$emit("input", this.tempValue );
        }
        this.$nextTick(()=>{
          this.$emit("change", val);
        })
      },
    },
    valueMap() {
      let res = {};
      if (this.multiple) {
        let valueList = this.myValue;
        for (let v of valueList) {
          res[v] = true;
        }
      } else {
        res[this.myValue] = true;
      }
      return res;
    },
    rowKey() {
      return this.multiple || this.isTree ? this.valueKey : "";
    },
    isFromServe() {
      if (this.isPage && this.model == "service") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch:{
    value(){
      if(this.notRefreshTable){
        this.notRefreshTable = false;
        return;
      }
      this.setCheck(this.tableData);
    }
  },
  methods: {
    hanleSearch() {
      this.tableLoadData();
    },
    hanleSearchInput() {
      if (this.isChangeSearch) {
        this.hanleSearch();
      }
    },
    handleTypeChange() {
      this.tableLoadData();
    },
    async tableLoadData(isNotFirst) {
      if (!isNotFirst) {
        this.tableCurrentPage = 1;
      }
      this.selectLoading = true;
      if (this.isFromServe) {
        let queryData = {
          rows: this.tablePageSize,
          page: this.tableCurrentPage,
          showType: this.showType,
        };
        if (this.showType == 2) {
          // 显示选择数据
          let ids = this.myValue;
          if (this.isPage) {
            ids = this.$pagination(
              this.tableCurrentPage,
              this.tablePageSize,
              this.myValue
            );
          }
          if (ids.length == 0) {
            this.tableTotal = 0;
            this.tableData = [];
            this.selectLoading = false;
            return;
          }
          queryData.ids = String(ids);

          if(this.isSaveSelectData){
            await this.loadClient();
            this.disabledRefresh = false;
            this.selectLoading = false;
            return;
          }

        }
        else{
          queryData.keyword = this.searchWord
        }

        if (this.loadSelectTable) {
          const res = await this.loadSelectTable(queryData);
          if (res) {
            this.setCheck(res.rows);
            this.tableData = res.rows;
            if (this.showType == 1) {
              this.tableTotal = res.records;
            } else {
              this.tableTotal = this.myValue.length;
            }

            this.selectLoading = false;
            this.disabledRefresh = false;
          } else {
            this.tableData = [];
            this.selectLoading = false;
            this.disabledRefresh = false;
          }
        } else {
          this.tableData = [];
          this.disabledRefresh = false;
          this.selectLoading = false;
        }
      } else {
        // 如果是客户端模式加载本地选中的数据
        await this.loadClient();
        this.disabledRefresh = false;
        this.selectLoading = false;
      }
    },
    turnTablePage({ rows }) {
      this.tablePageSize = rows;
      this.tableLoadData(true);
    },
    async loadClient() {
      let tableData = [];
      if (this.showType == 2) {
        tableData = await this.getSelected();
      } else {
        tableData = this.clientData;
        if(this.filterParams){
          let filterParams = this.filterParams
          tableData = tableData.filter((t) => {
            for(let key in filterParams){
              if(t[key] != filterParams[key]){
                return false;
              }
            }
            return true;
          });
        }
      }


      if (this.showType != 2  && !this.$validatenull(this.searchWord)) {
        let clientFilter = this.clientFilter;
        tableData = tableData.filter((t) => clientFilter(t));
      }

      if (this.isPage) {
        this.tableTotal = tableData.length;
        tableData = this.$pagination(
          this.tableCurrentPage,
          this.tablePageSize,
          tableData
        );
      }

      this.setCheck(tableData);
      this.tableData = tableData;
    },
    clientFilter(row) {
      const columns = this.columns;
      const searchWord = this.searchWord;
      for (let i = 0, len = columns.length; i < len; i++) {
        let value = row[columns[i].prop];
        if (value) {
          value += "";
          if (value.toLowerCase().indexOf(searchWord.toLowerCase()) != -1) {
            return true;
          }
        }
      }
      return false;
    },
    setCheck(rows) {
      if (this.multiple) {
        const valueMap = this.valueMap;
        const valueKey = this.valueKey;
        for (let row of rows) {
          let checkKey = false;
          if (valueMap[row[valueKey]]) {
            checkKey = true;
          }

          this.$set(row, "checkKey", checkKey);
        }

        if(this.isTree){
          this.$refs.selectTable.reLoadData();
        }
        else{
          let valueMap = this.valueMap;
          if(this.tableData.findIndex(t=>valueMap[t[valueKey]]) == -1){
            this.$refs.selectTable.clearSelection();
          }
        }
      }
    },
    handleSelect() {
      let valueKey = this.valueKey;
      let tableData = this.$refs.selectTable.getSelected(false);
      let selectValue = tableData.map((t) => t[valueKey]); // 赋值
      if (this.isPage) {
        let showData = this.tableData;
        let notLoadedValue = this.myValue.filter((t) => showData.findIndex(t2=>t == t2[valueKey]) == -1);
        selectValue.push(...notLoadedValue);
      }
      if(this.isSaveSelectData){
        let selectData = this.selectData;
        let showData = this.tableData;
        selectData = selectData.filter(t=>showData.findIndex(t2=>t2[valueKey] == t[valueKey]) == -1);
        let addList = tableData.filter(t=>selectData.findIndex(t2=>t2[valueKey] == t[valueKey]) == -1);
        selectData.push(...addList);
        this.selectData = selectData;
      }
      this.myValue = selectValue;
    },

    handleClear() {
      this.handleClearCheck();
      this.$nextTick(() => {
        this.tableLoadData();
      });
    },
    handleClearCheck() {
      this.showType = 1;
      if(this.multiple){
        this.myValue = [];
      }
      else{
        this.myValue = "";
      }

      this.searchWord = "";
      this.filterParams = null;
      if(this.isSaveSelectData){
        this.selectData = [];
      }
      this.$refs.selectTable.clearSelection();
    },
    handleRefresh() {
      this.handleClearCheck();
      this.$nextTick(async () => {
        this.disabledRefresh = true;
        if(this.refreshData){
          await this.refreshData();
        }
        else{
          await this.init();
        }
      });
    },
    // 单选
    handleRowClick({row}) {
      if (!this.multiple) {
        this.myValue = row[this.valueKey];
        console.log(this.myValue,'this.myValue');
        this.$emit("rowClick", {row});
      }
    },

    // 方法
    async init() {
      if (!this.isFromServe) {
        this.clientData = (await this.loadSelectTable()) || [];
      }
      await this.tableLoadData();
    },

    reset() {
      this.handleClearCheck();
      this.clientData = [];
      this.tableData = [];
    },
    toggleRowSelection(ids, selected){
      if(this.multiple){
        let values = this.myValue;
        if(selected){
          values.push(...ids.filter(t=>values.indexOf(t) == -1));
        }
        else{
          values = values.filter(t=>ids.indexOf(t) == -1);

          if(this.isSaveSelectData){
            let valueKey = this.valueKey;
            this.selectData =  this.selectData.filter(t=>ids.indexOf(t[valueKey]) == -1);
          }
        }
        this.myValue = values;

        //if(!selected)

        this.$nextTick(() => {
          this.setCheck(this.tableData);
        });
      }
    },
    async getSelected(isFull = true){
      let valueKey = this.valueKey;
      // 获取当前列表选中项。
      if(isFull && this.multiple){
        if(this.isSaveSelectData){
          return this.$deepClone(this.selectData);
        }

        if(this.isFromServe){
          let queryData = {
            rows: 20000,
            page: 1,
            showType: 2,
          };
          queryData.ids = String(this.myValue);
          const res = (await this.loadSelectTable(queryData)) || {};
          return res.rows || [];
        }
        else{
          let valueMap = this.valueMap;
          return this.clientData.filter(t=>valueMap[t[valueKey]]);
        }
      }
      else{
        let valueMap = this.valueMap;
        return this.tableData.filter(t=>valueMap[t[valueKey]]);
      }
    },
    filter(data){
      // 用在client 模式
      this.filterParams = data;
      this.tableLoadData();
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
